import type { CurrencyCode, Navigation } from '@noths/polaris-dev-ts-types';
import type { SerializedError } from '@reduxjs/toolkit';

import type { ReduxProductsCategory } from 'src/redux/types/category';
import type { BrowseDataAPIFilter } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';
import type { BrowseDataAPIProduct } from 'src/services/browse-data-api/types/BrowseDataAPIProduct';
import type { BrowseDataAPISortingOption } from 'src/services/browse-data-api/types/BrowseDataAPISortingOption';
import type { Partner } from 'src/types/partner';

export enum TriggerName {
  LOAD_MORE_PRODUCTS = 'loadMoreProducts',
  LOAD_PREVIOUS_PRODUCTS = 'loadPreviousProducts',
}

export interface ProviderMetadata {
  filter: string;
  pageCategories: string[];
}

export interface RequestProductsActionPayloadData {
  currencyCode: CurrencyCode;
  category: ReduxProductsCategory | null;
  filters: BrowseDataAPIFilter[];
  currentPage: number;
  totalPages: number;
  totalProducts: number;
  productsReturnedCount: number;
  perPage: number;
  queryType: string | null;
  sortingOptions: BrowseDataAPISortingOption[];
  navigation: Navigation[];
  partner?: Partner | null;
  errorCode?: string;
  errorMessage?: string;
  term: string | null;
  providerAttributionToken: string | null;
  products: BrowseDataAPIProduct[];
  zeroExactResults?: boolean;
  pinnedResultCount?: number;
  providerMetadata: ProviderMetadata | null;
}

export interface RequestProductsActionPayload {
  data?: RequestProductsActionPayloadData;
  triggerName?: TriggerName;
  redirectUrl?: string;
}

export interface ProductsState {
  currencyCode: CurrencyCode;
  deliveryZone?: string;
  searchTerm: string;
  items: Record<number, BrowseDataAPIProduct[]>;
  currentPage: number;
  pageLoading: number | null;
  totalPages: number;
  totalProducts: number;
  productsReturnedCount: number;
  queryType: string;
  isLoading: boolean;
  isUpdateFiltersLoading: boolean;
  category: ReduxProductsCategory | null;
  navigation: Navigation[];
  partner?: Partner;
  error?: SerializedError | null;
  redirectUrl?: string;
  providerAttributionToken: string | null;
  zeroExactResults?: boolean | null;
  pinnedResultCount?: number | null;
  showFewResultsMessage?: boolean;
  initialProductPage?: number;
  providerMetadata: ProviderMetadata | null;
}
